import * as React from 'react';
import classnames from 'classnames';

import styles from './styles.module.css';

export interface ReferHowItWorksProps {
  className?: string;
}

/**
 * @name ReferHowItWorks
 * @description A step by step break down of our referrals program
 */
export const ReferHowItWorks = (props: ReferHowItWorksProps) => {
  const { className } = props;

  // Styles
  const cssComponent = classnames(styles.component, className);
  const cssContainer = classnames('ui-container-lg', styles.container);
  const cssDot1 = classnames(styles.dot, styles.stormy);
  const cssDot2 = classnames(styles.dot);
  const cssDot3 = classnames(styles.dot, styles.rust);

  return (
    <div className={cssComponent}>
      <div className={cssContainer}>
        <h2 className={styles.heading}>How it works</h2>

        <div className={styles.reflow}>
          <div className="flex-1">
            <div className={cssDot1}>01&nbsp;</div>
            <h3 className={styles.subhead}>
              Tell your <span>friends</span>
            </h3>
            <p>If you're loving Haldi, tell your friends about it.</p>
          </div>

          <div className="flex-1">
            <div className={cssDot2}>02&nbsp;</div>
            <h3 className={styles.subhead}>
              They simply use <span>your link</span>
            </h3>
            <p>
              No codes needed. Your friend simply takes the skin quiz using your
              personalized link.
            </p>
          </div>

          <div className="flex-1">
            <div className={cssDot3}>03&nbsp;</div>
            <h3 className={styles.subhead}>
              Enjoy <span>free skincare</span>
            </h3>
            <p>
              When your friend makes a purchase from their Haldi store, we'll
              credit your account.
            </p>
          </div>
        </div>

        {/*
        <p className={styles.terms}>
          There is no limit on the number of friends you can refer. To qualify
          for One Year Free ($500) of skincare, 10 referrals must be made within
          3 months of sign up / start of this program. You will be notified via
          email and receive a store credit once a friend makes their first Haldi
          purchase. <AppLink href="/legal/terms">See terms</AppLink>
        </p>
        */}
      </div>
    </div>
  );
};
